import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Artists from "@/pages/Artists";
import Gallery from "@/pages/Gallery";
import KimaLooks from "@/pages/KimaLooks";
import KimaMatch from "@/pages/KimaMatch";
import Booking from "@/pages/Booking";
import Confirm from "@/pages/Confirm";
import Auth from "@/pages/Auth";
import ResetPassword from "@/pages/ResetPassword";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center font-serif text-2xl text-taupe">KIMA</div>;
  if (!user) return <Navigate to="/accedi" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servizi" element={<Services />} />
          <Route path="/nail-artists" element={<Artists />} />
          <Route path="/galleria" element={<Gallery />} />
          <Route path="/looks" element={<KimaLooks />} />
          <Route path="/kima-match" element={<KimaMatch />} />
          <Route path="/prenota" element={<Booking />} />
          <Route path="/prenota/conferma" element={<Confirm />} />
          <Route path="/accedi" element={<Auth />} />
          <Route path="/reimposta-password" element={<ResetPassword />} />
          <Route path="/kima-id" element={<Protected><ClientDashboard /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin", "receptionist", "staff"]}><AdminDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="top-center" toastOptions={{ style: { background: "#211C19", color: "#F6F2EC", border: "none" } }} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
